// extracted by mini-css-extract-plugin
export var actions = "_qp-5";
export var assistantBubble = "_qp-3";
export var assistantRow = "_qp-6";
export var bubble = "_qp-0";
export var humanAvatar = "_qp-4";
export var inlineToolCard = "_qp-1";
export var userBubble = "_qp-2";